import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import { NavLink } from 'reactstrap';
import { Link, useHistory } from 'react-router-dom';

import { reportCommReceivedLookup, reportCommReceivedFetchPage, reportCommReceivedPageUpdate } from '../../../redux/reportCommReceivedReducer';

import ReportCommReceivedFilter from './ReportCommReceivedFilter';
import ReportCommReceivedList from './ReportCommReceivedList';
import Pagination from '../../Pagination';

const useStyles = makeStyles({
    title: {
        "& a.nav-link": {
            padding: "0px",
        },

        "& a.nav-link:hover h1": {
            color: "#006ed0",
        },

        "& h1": {
            paddingBottom: "15px",
            fontSize: "26px",
            lineHeight: "26px",
            fontWeight: "bold",
        },
    },
});

export default function ReportCommReceived() {
    const classes = useStyles();

    const history = useHistory();

    const dispatch = useDispatch();

    const { filter } = useSelector(state => {
        return state.reportCommReceived;
    });

    const { jWTClaimModel: { Creds } } = useSelector(state => {
        return state.auth;
    });

    useEffect(() => {
        if (!Creds.includes("COMMISSION")) history.replace("/");

        dispatch(reportCommReceivedLookup());
    }, []);

    return (
        <>
            <Breadcrumbs className={classes.title}>
                <NavLink className="nav-link" tag={Link} to="/report">
                    <Typography variant="h1" className={classes.title}>7. 報告</Typography>
                </NavLink>
                <Typography variant="h1" className={classes.title}>7.3.1 已收佣金報告</Typography>
            </Breadcrumbs>

            <ReportCommReceivedFilter filter={filter} />
            <Pagination filter={filter} fnFetchPage={reportCommReceivedFetchPage} fnPageUpdate={reportCommReceivedPageUpdate} />
            <ReportCommReceivedList />
            <div style={{ margin: "5px", textAlign: 'center' }}>
                <Pagination filter={filter} fnFetchPage={reportCommReceivedFetchPage} fnPageUpdate={reportCommReceivedPageUpdate} />
            </div>
        </>
    );
}
